<div id="{{position}}" class="position-relative" [ngClass]="loading?'min-height':''">
  <div *ngIf="!loading"
    [ngStyle]="{ 'height': (minHeight$ | async)+'px','background-color': backgroundColor,'background-position': backgroundPosition?backgroundPosition:'center left','background-image': (style$ | async) }">
    <header class="app-header-background pb-40" [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="app-header-section global-max-width">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start center">
          <div fxFlex [fxFlexOrder]="imagePosition == 'right' ? 1 : 2" fxFlex.gt-md="100%" fxFlex.lt-sm="100%"
            [attr.data-aos]="textAnimation ? textAnimation : null" data-aos-duration="1100">
            <div class="app-header-headline">
              <h1
                [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'font-weight': fontWeight,'color': titleColor?titleColor:textColor,'line-height': lineHeight }"
                [style.textAlign]="textAlign" class="mat-h1" [ngClass]="[titleSize]" [innerHtml]="title | safeHtml">
              </h1>
              <h2 [ngStyle]="{ 'color': textColor }" [class]="textSize" [ngStyle]="{ 'color': textColor }"
                [style.textAlign]="textAlign" [innerHtml]="text | safeHtml"></h2>
            </div>
            <div [style.textAlign]="textAlign" style="margin: 0px;" class="app-header-start"
              *ngIf="buttonText && buttonsDisplay!=0">

              <ng-container *ngIf="buttonLink && buttonLink.includes('#') && buttonLink.length<5; else externalLink">
                <button class="app-button mat-raised-button"
                  [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                  [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                  mat-raised-button (click)='navigateTo(buttonLink)' rel="noopener">
                  <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                    {{buttonIcon?buttonIcon:'check_circle'}}</mat-icon>
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </button>
                <!-- <a class="app-button mat-raised-button" mat-raised-button (click)='navigateTo(buttonLink)'
                  rel="noopener">
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </a> -->
              </ng-container>
              <ng-template #externalLink>
                <button class="app-button mat-raised-button" mat-raised-button style="cursor: pointer"
                  (click)="clickExternalLink(buttonLink)" rel="noopener"
                  [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                  [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}">
                  <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                    {{buttonIcon?buttonIcon:'check_circle'}}</mat-icon>
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </button>
                <!-- <a class="app-button mat-raised-button" mat-raised-button style="cursor: pointer"
                  (click)="clickExternalLink(buttonLink)" rel="noopener">
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </a> -->
              </ng-template>
              <span *ngIf="secondButtonText && buttonsDisplay==2">
                <ng-container
                  *ngIf="secondButtonLink && secondButtonLink.includes('#') && secondButtonLink.length<5; else externaseceondlLink">
                  <a class="app-button mat-raised-button second-button" mat-raised-button
                    [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                    [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                    (click)='navigateTo(secondButtonLink)' rel="noopener">
                    <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                      {{secondaryButtonIcon?secondaryButtonIcon:'check_circle'}}</mat-icon>
                    <span class="mat-button-wrapper"> {{ secondButtonText }} </span>
                  </a>
                </ng-container>
                <ng-template #externaseceondlLink>
                  <a class="app-button mat-raised-button second-button" mat-raised-button
                    [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                    [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                    [href]="secondButtonLink | safeUrl" [target]="'_blank'" rel="noopener">
                    <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                      {{secondaryButtonIcon?secondaryButtonIcon:'check_circle'}}</mat-icon>
                    <span class="mat-button-wrapper"> {{ secondButtonText }} </span>
                  </a>
                </ng-template>
              </span>
            </div>
          </div>
          <div [fxFlexOrder]="imagePosition == 'right' ? 2 : 1" fxFlex fxFlexOrder="1" fxFlex.gt-md="100%"
            fxFlex.lt-sm="100%">
            <div *ngIf="picture">
              <div class="feature-image" [attr.data-aos]="imageAnimation ? imageAnimation : null">
                <div class="feature-image-inner">
                  <img [ngStyle]="{ 'border-radius': (borderRadius$ | async)+'px'}" [src]="picture" class="hero-image" [alt]="title">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
<style *ngIf="buttonStyle == 'style3' || buttonStyle == 'style2'">
  .style3:hover {
    color: var(--button-color-hero-image) !important;
    background-color: var(--button-background-hero-image) !important;
  }

  .style2:hover {
    color: var(--button-color-hero-image) !important;
    background-color: var(--button-background-hero-image) !important;
  }
</style>